import React from "react";
import WagerTypes from "../constants/WagerTypes";
import EntriesTable from "./EntriesTable";

const DailyDouble = ({ raceInfo, idDD, addToCart, entries }) => {
  let tablesDD = [];
  // order races for race number
  entries.sort((a, b) => (a[0].RaceNumber < b[0].RaceNumber ? -1 : 0));

  entries &&
    entries.forEach((element, index) => {
      tablesDD.push(
        <div key={index} style={{ borderTop: "1px solid #dee2e6" }}>
          <span
            style={{
              color: "#005580",
              fontFamily: "fantasy",
              fontSize: "20px",
            }}
          >
            R{element[0].RaceNumber}
          </span>
          <EntriesTable
            raceInfo={raceInfo}
            entriesInfo={element}
            wt={WagerTypes.DAILYDOUBLE.name}
            idWT={idDD}
            addToCart={addToCart}
            positionLeg={index}
            raceID={element[0].RaceID}
          />
        </div>
      );
    });

  return (
    <>
      <div
        className="tab-pane fade show active"
        id="DailyDouble"
        role="tabpanel"
        aria-labelledby="DailyDouble"
      >
        <div className="wrapper">{tablesDD}</div>
      </div>
    </>
  );
};

export default DailyDouble;
